
export default function Scenes() {
  const cases = [
    {
      icon: 'ri-computer-line',
      title: '制御盤・サーバー室',
      description: '粉塵によるデータ消失やショートを防ぐために。',
      image:
        'https://readdy.ai/api/search-image?query=industrial%20control%20panel%20room%20with%20electrical%20cabinets%20and%20server%20racks%20in%20clean%20modern%20factory%20environment%20with%20blue%20lighting%20professional%20industrial%20setting&width=600&height=400&seq=scene-001&orientation=landscape',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      icon: 'ri-flashlight-line',
      title: '溶接・切断エリア',
      description: 'スパッタによるボヤ対策に。作業者の腰袋に常備できるサイズ。',
      image:
        'https://readdy.ai/api/search-image?query=welding%20work%20area%20in%20industrial%20factory%20with%20sparks%20flying%20from%20metal%20cutting%20equipment%20worker%20safety%20zone%20with%20protective%20gear%20and%20tools&width=600&height=400&seq=scene-002&orientation=landscape',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      icon: 'ri-truck-line',
      title: 'フォークリフト・社用車',
      description: '90℃耐熱だから、真夏の車内でも破裂しません。',
      image:
        'https://readdy.ai/api/search-image?query=forklift%20and%20company%20vehicles%20in%20warehouse%20loading%20dock%20area%20industrial%20logistics%20transportation%20zone%20with%20clean%20organized%20environment&width=600&height=400&seq=scene-003&orientation=landscape',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      icon: 'ri-restaurant-line',
      title: '食堂・休憩室',
      description: '天ぷら油火災に対応。従業員の憩いの場を守る。',
      image:
        'https://readdy.ai/api/search-image?query=modern%20factory%20cafeteria%20and%20break%20room%20with%20kitchen%20area%20clean%20bright%20employee%20dining%20space%20with%20tables%20and%20cooking%20facilities&width=600&height=400&seq=scene-004&orientation=landscape',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    },
  ];

  return (
    <section id="scenes" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="scenes-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ lineHeight: '1.5' }}>
            <span className="scenes-heading-line1">工場の「リスク」に合わせて</span>
            <br />
            局所配備してください
          </h2>
          <p className="scenes-desc text-lg text-gray-700 max-w-3xl mx-auto">
            それぞれの現場に潜む火災リスクに対応。FIRE
            OUTを適切な場所に配置することで、工場全体の安全性を高めます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {cases.map((caseItem, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div
                className="h-64 bg-cover bg-center relative"
                style={{
                  backgroundImage: `url(${caseItem.image})`,
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className={`absolute top-4 left-4 ${caseItem.bgColor} rounded-full p-3`}>
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${caseItem.icon} text-3xl ${caseItem.color}`}></i>
                  </div>
                </div>
              </div>
              <div className="p-8">
                <h3 className="scenes-card-title text-2xl font-bold text-gray-900 mb-4">{caseItem.title}</h3>
                <p className="text-gray-700 leading-relaxed">{caseItem.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-10">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-6 md:mb-0">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                配置場所にお悩みですか？
              </h3>
              <p className="text-lg text-gray-700">
                専門スタッフが最適な配置プランをご提案いたします。
              </p>
            </div>
            <a
              href="https://fireout.stores.jp/inquiry"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              無料お見積り・導入のご相談
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #scenes {
            padding-top: 2rem !important;
            padding-bottom: 2rem !important;
          }
          .scenes-heading {
            font-size: 1.5rem !important;
            line-height: 1.6 !important;
          }
          .scenes-heading-line1 {
            white-space: nowrap;
            font-size: 1.3rem;
          }
          .scenes-desc {
            font-size: 0.85rem !important;
            line-height: 1.7 !important;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-bottom: 0.5rem !important;
          }
          .scenes-card-title {
            font-size: 1.1rem !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      `}</style>
    </section>
  );
}
